// extracted by mini-css-extract-plugin
export default {"dangerZone":"ClubDangerZone_dangerZone__zRYc-","title":"ClubDangerZone_title__SFemN","box":"ClubDangerZone_box__sPvZ5","deleteButton":"ClubDangerZone_deleteButton__cD8D7"};